import React, { Component } from 'react';
import LoaderComponent from 'components/loader/LoaderComponent';

import './MPGSRedirectScreen.scss';
import { datadogLogs } from '@datadog/browser-logs';
import {
  isLegacyPartnersCallback,
  isPaymentsAppsCallback,
  redirectToPaymentsAppsCallback
} from '../../utils/shopifyRedirect';

class MPGSRedirectScreen extends Component {
  render() {
    const searchParams = new URLSearchParams(window.location.search);
    const url = searchParams.get('url');
    const sourceId = searchParams.get('id');

    if (url) {
      if (isPaymentsAppsCallback(url)) {
        redirectToPaymentsAppsCallback(url, { source_id: sourceId });
      } else if (window.top !== window.parent) {
        if (isLegacyPartnersCallback(url)) {
          // Skip redirect for Shopify checkout iframe
          datadogLogs.logger.info('Skipping redirect for Shopify checkout iframe', {
            data: {
              redirect_url: url,
              source_id: sourceId
            }
          });
        } else {
          // If inside an iframe use window.self to redirect
          datadogLogs.logger.info('Notify organization of complete payment', {
            data: {
              callback_type: 'iframe top not same as parent',
              notification_type: 'redirect to return URL',
              redirect_url: url,
              source_id: sourceId
            }
          });

          window.self.location.href = url;
        }
      } else {
        datadogLogs.logger.info('Notify organization of complete payment', {
          data: {
            notification_type: 'redirect to return URL',
            source_id: sourceId,
            redirect_url: url
          }
        });

        window.top.location.href = url;
      }
    }

    return (
      <div className="MPGSRedirectScreen">
        <div className="Container">
          {url ? <LoaderComponent spinning /> : <p className="Header"> Redirect URL not found </p>}
        </div>
        <div />
      </div>
    );
  }
}

export default MPGSRedirectScreen;
